import React from "react";
import { FiCheck } from "react-icons/fi";

const WhatWeDo = () => {
    const industries = [
        "Hospitals",
        "Textile Mills",
        "Sugar Plants",
        "Paper Mills",
        "Foundries",
        "Engineering Industries",
        "Cement Plants",
        "Thermal Power Plants",
        "Commercial Complexes",
        "Co-Generation Plants",
        "Large Industrial Facilities"
    ];

    return (
        <div className="about-area rn-section-gap what-we-do">
            <div className="container">
                <div className="row row--40 align-items-start">

                    {/* LEFT CONTENT */}
                    <div className="col-lg-5">
                        <div className="inner">
                            <h3 className="title text-primary">What We Do</h3>
                            <h4 className="subtitle">Electrical Contracting & Industrial Solutions</h4>

                            <p className="description">
                                We execute complete electrical installations, panel works,
                                and industrial power infrastructure for major sectors across India.
                            </p>
                        </div>
                    </div>

                    {/* RIGHT — 2 COLUMN LIST */}
                    <div className="col-lg-7">
                        <ul 
                            className="feature-list"
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "15px 20px",
                                paddingLeft: 0,
                                listStyle: "none"
                            }}
                        >
                            {industries.map((item, index) => (
                                <li 
                                    key={index} 
                                    style={{ display: "flex", alignItems: "center" }}
                                >
                                    <div className="icon" style={{ marginRight: "10px" }}>
                                        <FiCheck />
                                    </div>
                                    <h4 className="title" style={{ margin: 0 }}>
                                        {item}
                                    </h4>
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default WhatWeDo;
